module.exports = __webpack_public_path__ + "img/bars.f189b03b.svg";